/**
 * 解析旋转特征语义类型。
 *
 * @param params 旋转参数。
 * @returns 归一化后的旋转特征类型。
 */
export const resolveRevolveFeatureKind = (params: RevolveParams): RevolveFeatureKind => {
  if (params.featureKind === 'cut-revolve') {
    return 'cut-revolve';
  }

  if (params.operation === 'cut') {
    return 'cut-revolve';
  }

  return 'boss-revolve';
};